import { render, staticRenderFns } from "./AccordionResearch.vue?vue&type=template&id=356bf6f4"
import script from "./AccordionResearch.vue?vue&type=script&lang=js"
export * from "./AccordionResearch.vue?vue&type=script&lang=js"
import style0 from "./AccordionResearch.vue?vue&type=style&index=0&id=356bf6f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports